import { useRef, useCallback, useState } from 'react'
import type { TurnstileRef } from 'components/atoms/turnstile'

export function useTurnstile() {
	const turnstileRef = useRef<TurnstileRef>(null)
	const [token, setToken] = useState<string | null>(null)

	const onSuccess = useCallback((t: string) => {
		setToken(t)
	}, [])

	const onExpire = useCallback(() => {
		setToken(null)
	}, [])

	const onError = useCallback(() => {
		setToken(null)
	}, [])

	const reset = useCallback(() => {
		setToken(null)
		turnstileRef.current?.reset()
	}, [])

	return {
		turnstileRef,
		token,
		onSuccess,
		onExpire,
		onError,
		reset,
	}
}
